module.exports = function() {
  return new Worker(__webpack_public_path__ + "6fda868eeb3f5e447d36.worker.js");
};